import { render, staticRenderFns } from "./richCalendar.vue?vue&type=template&id=79ada2d8&scoped=true&"
import script from "./richCalendar.vue?vue&type=script&lang=js&"
export * from "./richCalendar.vue?vue&type=script&lang=js&"
import style0 from "./richCalendar.vue?vue&type=style&index=0&id=79ada2d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ada2d8",
  null
  
)

export default component.exports